// extracted by mini-css-extract-plugin
export var body = "_mg-0";
export var sectionHeader = "_mg-4";
export var shortcutColumns = "_mg-2";
export var shortcutList = "_mg-1";
export var shortcutSection = "_mg-3";